import * as v from "valibot";
import { TIP_AMOUNTS } from "../tips";

export const createTipCheckoutRequest = {
  tipAmount: v.picklist(TIP_AMOUNTS),
};
export const createTipCheckoutResponse = {
  /** The Stripe Checkout page to send the visitor to. */
  sessionUrl: v.string(),
};

export const requestAccountDeletionRequest = {
  /** Where the confirmation link should fall back to after the app scheme is tried. */
  source: v.optional(v.picklist(["web", "mobile"])),
};

export const confirmAccountDeletionRequest = {
  token: v.pipe(v.string(), v.minLength(1), v.maxLength(100)),
};

export const signOutRequest = {
  /** Revokes this refresh token when given. */
  refreshToken: v.optional(v.string()),
};

export const getMinVersionRequest = {
  platform: v.optional(v.picklist(["ios", "android"])),
};
export const getMinVersionResponse = {
  /** The oldest app version that still works, "major.minor.patch". */
  minVersion: v.string(),
  /** Shown to a user running an older version, set on the admin hub's Platform > App config page. */
  message: v.string(),
};
